import { ConfigItem } from "@flanksource-ui/api/types/configs";
import { HealthCheck } from "@flanksource-ui/api/types/health";
import { NotificationSendHistoryApiResponse } from "@flanksource-ui/api/types/notifications";
import { Topology } from "@flanksource-ui/api/types/topology";
import { MRTDateCell } from "@flanksource-ui/ui/MRTDataTable/Cells/MRTDateCells";
import MRTDataTable from "@flanksource-ui/ui/MRTDataTable/MRTDataTable";
import { MRT_ColumnDef } from "mantine-react-table";
import { CheckLink } from "../Canary/HealthChecks/CheckLink";
import ConfigLink from "../Configs/ConfigLink/ConfigLink";
import { TopologyLink } from "../Topology/TopologyLink";

const notificationSendHistoryColumns: MRT_ColumnDef<NotificationSendHistoryApiResponse>[] =
  [
    {
      header: "Resource",
      Cell: ({ row }) => {
        const resource = row.original.resource;

        const resourceType = row.original.resource_type;

        return (
          <div
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            className="flex flex-row items-center"
          >
            {resourceType === "check" && (
              <CheckLink check={resource as HealthCheck} />
            )}
            {resourceType === "config" && (
              <ConfigLink config={resource as ConfigItem} />
            )}
            {resourceType === "component" && (
              <TopologyLink topology={resource as Topology} />
            )}
          </div>
        );
      }
    },
    {
      header: "Status",
      Cell: ({ row }) => {
        const status = row.original.status;
        return <span>{status}</span>;
      }
    },
    {
      header: "Body",
      Cell: ({ row }) => {
        const body = row.original.body;
        return <span>{body}</span>;
      }
    },
    {
      header: "Count",
      Cell: ({ row }) => {
        const count = row.original.count;
        return <span>{count}</span>;
      }
    },
    {
      header: "First Observed",
      Cell: MRTDateCell,
      accessorKey: "first_observed"
    },
    {
      header: "Source Event",
      Cell: ({ row }) => {
        const sourceEvent = row.original.source_event;
        return <span>{sourceEvent}</span>;
      }
    },
    {
      header: "Age",
      accessorKey: "created_at",
      Cell: (props) => {
        return <MRTDateCell {...props} />;
      }
    }
  ];

type NotificationSendHistoryListProps = {
  data: NotificationSendHistoryApiResponse[];
  isLoading: boolean;
  onRowClick?: (row: NotificationSendHistoryApiResponse) => void;
  refresh?: () => void;
  pageCount: number;
  sendHistoryRowCount: number;
};

export default function NotificationSendHistoryList({
  data,
  isLoading,
  onRowClick = () => {},
  pageCount,
  sendHistoryRowCount
}: NotificationSendHistoryListProps) {
  return (
    <MRTDataTable
      data={data}
      columns={notificationSendHistoryColumns}
      isLoading={isLoading}
      onRowClick={onRowClick}
      manualPageCount={pageCount}
      totalRowCount={sendHistoryRowCount}
      enableServerSidePagination
      enableServerSideSorting
    />
  );
}
